<template>
  <div class="basicInfor_right basicNew">
    <div class="basicTelte">
      <div class="house-basicInfoR-warpper">
        <div class="shop_name_price_area">
          <div class="shop_name_price">
            <span class="shop_name">
              {{ housesData.shopName }}
              <a-tag
                class="tag_house_status"
                color="var(--ThemeColor)"
                v-if="housesData.houseStatus === '1'"
              >上架
              </a-tag>
              <a-tag
                class="tag_house_status"
                color="var(--ThemeColor)"
                v-if="housesData.houseStatus === '2'"
              >我司成交
              </a-tag>
              <a-tag
                class="tag_house_status"
                color="var(--ThemeColor)"
                v-if="housesData.houseStatus === '3'"
              >自行成交
              </a-tag>
              <a-tag
                class="tag_house_status"
                color="var(--ThemeColor)"
                v-if="housesData.houseStatus === '4'"
              >无效
              </a-tag>
              <a-tag
                class="tag_house_status"
                color="var(--ThemeColor)"
                v-if="housesData.houseStatus === '5'"
              >无效
              </a-tag>
              <a-tag
                class="tag_house_status"
                color="var(--ThemeColor)"
                v-if="housesData.houseStatus === '6'"
              >下架
              </a-tag>
            </span>
            <div class="price">
              <div class="priceInfor">
                <div class="priceHousin">{{ housesData.rentFee || '--' }}元/月</div>
                <div
                  class="priceTag"
                  v-if="housesData.beforeRentFee && Number(housesData.rentFee) - housesData.beforeRentFee != 0"
                >
                  {{ Math.abs(housesData.beforeRentFee - Number(housesData.rentFee)).toFixed(2) }}
                  <a-icon
                    v-if="Number(housesData.rentFee) - housesData.beforeRentFee > 0 && housesData.beforeRentFee"
                    type="arrow-up"
                    style="font-size: 12px; color: #fff"
                  >
                  </a-icon>
                  <a-icon
                    v-else-if="housesData.beforeRentFee && housesData.beforeRentFee - Number(housesData.rentFee) > 0"
                    type="arrow-down"
                    style="font-size: 12px; color: #fff"
                  >
                  </a-icon>
                </div>
                <div v-else class="priceTag">无变更</div>

                <div class="price_transferFee" v-if="housesData.isHaveTransferFee === 'Y'">
                  <span>转让费：</span><span>{{ housesData.transferFee || '--' }}万元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="dish_tag_area_floor">
            <div class="dish_tag">
              <a-tag class="dish_type" color="green">
                {{ housesData.dishType | filterDict(dishTypeOpts) }}
              </a-tag>
              <a-tag color="green" v-if="housesData.isCatering === 'Y' && housesData.alloweCateringTypeId">
                {{ housesData.alloweCateringTypeId | filterDict(repastTypeOpts) }}
              </a-tag>
              <a-tag color="green" v-else>
                <div><span>拒餐饮</span></div>
              </a-tag>
            </div>
            <div class="housArea">
              <div class="areaInfor">建：{{ housesData.grossFloorArea }}m²，实：{{ housesData.saleableArea }}m²</div>
              <div class="houseup">{{ housesData.houseFloor }}层，共{{ housesData.floorTotal }}层</div>
            </div>
          </div>
        </div>

        <div class="house_special">
          <div class="basicTelteTu">
            <div class="detail-t">
              <!-- <span
                :class="{ font_light: housesData.identityAlone == 'Y', font_gray: housesData.identityAlone != 'Y' }"
              >
                独
              </span> -->
              <img
                class="icon_tag_key"
                :class="{ img_gray: housesData.identityAlone != 'Y' }"
                src="@/assets/icons/icon_du.png"
                title=""
                alt=""
              />
            </div>
            <div class="detail-t">
              <!-- <span :class="{ font_light: housesData.identityFive == 'Y', font_gray: housesData.identityFive != 'Y' }">
                五
              </span> -->
              <img
                class="icon_tag_key"
                :class="{ img_gray: housesData.identityFive != 'Y' }"
                src="@/assets/icons/icon_5.png"
                title=""
                alt=""
              />
            </div>
            <div class="detail-t">
              <!-- <span
                :class="{
                  font_light: housesData.identityExcellent == 'Y',
                  font_gray: housesData.identityExcellent != 'Y',
                }"
              >
                优
              </span> -->
              <img
                class="icon_tag_key"
                :class="{ img_gray: housesData.identityExcellent != 'Y' }"
                src="@/assets/icons/icon_good.png"
                title=""
                alt=""
              />
            </div>
            <div class="detail-t">
              <!-- <span
                class="iconfont icon-yuechi"
                :class="{ font_light: housesData.identityKey == 'Y', font_gray: housesData.identityKey != 'Y' }"
                style="cursor: unset"
              ></span> -->
              <img
                class="icon_tag_key"
                :class="{ img_gray: housesData.identityKey != 'Y' }"
                src="@/assets/icons/icon_key.png"
                title=""
                alt=""
              />
            </div>
          </div>
        </div>
        <a-divider style="margin:0 0 16px 0" />
        <div class="houseInfor">
          <div class="address">
            <div class="housin">
              {{ housesData.districtName }},{{ housesData.businessDistrictName }},{{ housesData.streetName }}
              <span>
                ,{{ housesData.houseNumber }}号
                {{ housesData.houseNumberDeputy ? ',附' + housesData.houseNumberDeputy + '号' : '' }}
              </span>
            </div>
          </div>
        </div>
        <div class="list_info">
          <dl class="item_info">
            <dt class="item_info_name">房源编号：</dt>
            <dd
              class="item_info_val tag-read"
              :class="{ copySelClass: curText === housesData.houseCode }"
              :data-clipboard-text="housesData.houseCode"
              @click="copy(housesData.houseCode)"
            >
              {{ housesData.houseCode }}
            </dd>
          </dl>
          <dl class="item_info">
            <dt class="item_info_name">小区名称：</dt>
            <dd class="item_info_val">{{ housesData.communityName }}</dd>
          </dl>
          <dl class="item_info">
            <dt class="item_info_name">商铺配套：</dt>
            <dd class="item_info_val">
              {{ housesData.shopAncillary ? housesData.shopAncillary.split(',').join('、') : '暂无' }}
            </dd>
          </dl>
          <!-- <dl class="item_info">
            <dt class="item_info_name">客流人群：</dt>
            <dd class="item_info_val">{{ housesData.trafficCrowd }}</dd>
          </dl> -->
          <dl class="item_info">
            <dt class="item_info_name">消费配套：</dt>
            <dd class="item_info_val">
              {{ housesData.consumeAncillary ? housesData.consumeAncillary.split(',').join('、') : '暂无' }}
            </dd>
          </dl>
          <dl class="item_info">
            <dt class="item_info_name">自定义标签：</dt>
            <dd class="item_info_val">
              <!-- <a-tag color="yellow" v-if="housesData.tagsContentArray"> -->
              {{ housesData.tagsContentArray ? housesData.tagsContentArray.split(',').join('、') : '暂无' }}
              <!-- </a-tag> -->

            </dd>
          </dl>
          <dl class="item_info">
            <dt class="item_info_name">经营状态：</dt>
            <dd class="item_info_val">{{ housesData.operatingStatusId | filterDict(operatingStatusOpts) }}</dd>
          </dl>
          <dl class="item_info" v-if="rentSaleType==='1'">
            <dt class="item_info_name">委 托：</dt>
            <dd class="item_info_val">
              <p v-if="housesData.isEntrust === 'N'" tyle="display: flex; margin-right: 3px">
                暂无委托，<a-button type="link" @click="showuploadmoadl(7)">上传</a-button>
              </p>
              <p v-else>
                已上传委托 <a-button v-if="housesData.accendantId === uid||controlJurisdiction" @click="viewEntrust" type="link">查看</a-button>
                <!-- controlJurisdiction -->
                <a-button
                  v-if="housesData.accendantId !== uid"
                  v-hasPermi="['houses:houseInfo:viewEntrust']"
                  @click="viewEntrust"
                  type="link"
                >查看</a-button
                >
              </p>
            </dd>
          </dl>
          <dl class="item_info">
            <dt class="item_info_name">钥 匙：</dt>
            <dd class="item_info_val">
              <p v-if="housesData.identityKey == 'N'" tyle="display: flex; margin-right: 3px">
                暂无钥匙<a-button v-if="isKey" type="link" @click="showuploadmoadl(6, 'add')">上传钥匙</a-button>
              </p>
              <div v-else class="actionKey">
                <div v-hasPermi="['house:key:connect']">
                  {{ housesData.keyTeamName }},{{ housesData.keyUserName }}
                  <a-button type="link" @click="showuploadmoadl(6, 'edit')">交接钥匙</a-button>
                </div>
                <div v-if="AManager">
                  <a-popconfirm title="确认下架钥匙吗？" @confirm="handleKey">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="#">下架钥匙</a>
                  </a-popconfirm>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>

    <div class="follow-up" v-if="newFollowUpMsg && newFollowUpMsg.createByName">
      <h1 class="title">最新跟进：</h1>
      <div class="msg">
        <div>
          <h1>{{ newFollowUpMsg.createByName }}</h1>
          <p>{{ newFollowUpMsg.createTime }}</p>
        </div>
        <div class="describe">
          {{ newFollowUpMsg.recordContent }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { copyTextMixin } from '@/mixin/copyTextMixin'
import houseApi from '@/api/system/houses/house.js'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
export default {
  data () {
    const userInfo = this.$getters.userInfo
    const isKey = userInfo.data.permissions.includes('house:key:uploading') || userInfo.data.permissions.includes('*:*:*')

    return {
      AManager: false,
      isKey,
      dishTypeOpts: [],
      repastTypeOpts: [],
      operatingStatusOpts: []
    }
  },
  mixins: [copyTextMixin],
  components: {
    QuestionCircleOutlined
  },
  props: {
    aManager: {
      type: Boolean,
      default: false
    },
    housesData: {
      type: Object,
      default: () => {}
    },
    rentSaleType: {
      type: String,
      default: '1',
      require: true
    },
    controlJurisdiction: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number | String,
      default: undefined
    },
    newFollowUpMsg: {
      type: Object,
      default: () => {}
    },
    industryCategoryJsonName: {
      type: Array,
      default: () => []
    },
    industryCategoryVoList: {
        type: Array,
        default: () => []
    },
    industrySubclassJsonName: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    console.log(this.$route.query.userStatus, '是否离职 0正常 1离职')
    // 盘别
    this.getDicts('dish_type').then((response) => {
      this.dishTypeOpts = response.data
    })
    this.getDicts('operating_status').then((response) => {
      this.operatingStatusOpts = response.data
    })
    this.getDicts('repast_type').then((response) => {
      this.repastTypeOpts = response.data
    })
  },
  watch: {
    housesData: {
     handler (val) {
      // console.log(val, 'housesData')
     },
     deep: true,
     immediate: true
    },
    aManager: {
      handler: function (newVal, oldVal) {
        this.AManager = newVal
      },
      deep: true,
     immediate: true
    },
    industryCategoryVoList: {
     handler (val) {
      // console.log(val,'val')
     },
     deep: true,
     immediate: true
    }
  },
  methods: {
    // 确认下架钥匙
    handleKey () {
      houseApi
        .houseSoldOut({
          houseId: this.housesData.id,
          rentSaleType: this.rentSaleType
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('下架钥匙成功！')
            this.getHouseDetails()
          }
        })
    },
    // 获取房源的详细信息
    getHouseDetails () {
      this.$emit('getHouseDetails')
    },
    showuploadmoadl (index, opt) {
      this.$emit('showuploadmoadl', index, opt)
    },
    viewEntrust () {
      this.$emit('viewEntrust')
    }
  }
}
</script>
<style lang="less" scoped>

.actionKey {
  display: flex;
  align-items: center;
}
.copySelClass {
  background: var(--ThemeColor);
}
.detail-t {
  // cursor: pointer;
  .font_red,
  .font_light {
    // color:#ff0000;
    // cursor: pointer;
    // background: #fff1f0;
    color: #f5222d;
    // border: 1px solid #f5222d;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -ms-border-radius: 4px;
    -moz-border-radius: 4px;
    padding: 0 5px;
  }
  .font_light.icon-yuechi {
    cursor: none;
    color: gold;
    background: none;
    border: none;
  }
  .font_gray {
    cursor: pointer;
    color: #ccc;
  }
}
.basicInfor_right {
  width: calc(42% - 30px);
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  .follow-up {
    margin-top: 26px;
    margin-bottom: 20px;
    display: flex;
    // border:1px solid #f2f6fc;
    // padding: 20px;
    .title {
      width: 90px;
      font-weight: 700;
    }
    .msg {
      width: calc(100% - 90px);
      min-width: 200px;
      > div {
        display: flex;
        justify-content: space-between;
      }
      .describe {
        display: flex;
        flex-wrap: wrap;
        // width: 400px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }
      h1 {
        font-weight: 700;
      }
    }
  }
}
.basicNew {
  .basicTelte {
    width: 100%;
    display: flex;
    flex-direction: column;
    // margin-top: 15px;
    .basicTelteTu {
      display: flex;
      flex-direction: row;
      position: relative;
      // top: -3px;
      width: 200px;
      height: 40px;
      margin: 10px 0;
      // background: #f6ffed;
      justify-content: space-around;
      align-items: center;
      // box-shadow: 1px 1px 3px #ccc;
      // -webkit-box-shadow: 1px 1px 3px #ccc;
      // border-radius:3px;
      // -webkit-border-radius:3px;
      .detail-t {
        width: 40px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        line-height: 40px;
        // box-shadow: 1px 1px 3px #ccc;
        // -webkit-box-shadow: 1px 1px 3px #ccc;
        .icon_tag_key {
          padding: 3px;
          width: 28px;
          height: 28px;
          background: rgba(255, 255, 255, 0.8);
          // object-fit: cover;
        }
        .img_gray {
          opacity: 0.3;
        }
      }
      .detail-t:first-child {
        margin-left: 0;
      }
    }
    .house-basicInfoR-warpper {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      .shop_name_price_area {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: space-between;
        // width: 90%;
        width: 100%;
        .shop_name {
          // font-size: 20px;
          font-size: 24px;
          font-weight: bold;
          color: #222;
        }
      }

      .basicTeltexi {
        font-size: 24px;
        margin-right: 50px;
        font-weight: bold;
        color: #222222;
        line-height: 40px;
        display: flex;
        flex-direction: column;
        .tag_house_status {
          width: 50px;
          text-align: center;
          margin-bottom: 20px;
        }
      }

      .price {
        margin-bottom: 20px;
        .priceInfor {
          display: flex;
          align-items: center;
          .priceHousin {
            // font-size: 16px;
            font-size: 20px;
            font-weight: bold;
            color: #000;
          }
          .priceTag {
            background: #2fba6c;
            color: #fff;
            height: 17px;
            padding: 0 5px;
            font-size: 12px;
            line-height: 17px;
            margin-top: 2px;
            margin-left: 7px;
          }
          .price_transferFee {
            margin-left: 30px;
            font-size: 18px;
            // font-size:14px;
            color: #222;
          }
        }
        .houseup {
          font-size: 20px;
          color: #222222;
        }
      }
      .dish_tag_area_floor {
        display: flex;
        align-items: center;
        .dish_tag {
          .dish_type {
            background: green;
            color: #fff;
            border-radius: 10px;
            -webkit-border-radius: 10px;
          }
        }
        .housArea {
          margin-left: 10px;
          .areaInfor {
            font-weight: bolder;
            color: #222;
          }
        }
      }
      // .dish_tag{
      //    .dish_type{
      //       background: green;
      //       color: #fff;
      //       border-radius: 10px;
      //       -webkit-border-radius: 10px;
      //    }
      //   }
      .house_special {
        width: 100%;
        margin: 0px 0 0 0;
      }
    }
    .list_info {
      width: 100%;
      display: flex;
      // flex-direction: column;
      flex-direction: row;
      flex-wrap: wrap;
      .item_info {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        color: #222;
        line-height: 30px;
        margin: 0;
        .item_info_val {
          margin: 0;
          padding: 0;
          p {
            margin: 0;
          }
        }
      }
    }
  }
  .houseTag {
    margin: 10px 0px;
  }

  .houseInfor {
    display: flex;
    flex-direction: column;
    // margin-top: 13px;
    // margin-bottom: 20px;
    .address {
      margin-bottom: 20px;
      .housin {
        font-size: 14px;
        font-weight: bold;
        color: #000;
      }
      .houseup {
        font-size: 12px;
        color: #000;
      }
    }

    .housArea {
      margin-right: 20px;
      .areaInfor {
        font-size: 14px;
        font-weight: bold;
        color: #000;
      }
      .houseup {
        font-size: 12px;
        color: #000;
      }
    }
  }
}
</style>
